import React, { useContext } from 'react';
import { TemplateContext } from '../layout';

const Header = (data) => {
	const [templateContext, setTemplateContext] = useContext(TemplateContext);
	return (
		<header>
			<div className="topLine">
				<img className="topLine__logo" src={window.general_settings.logo} alt={null} />
				{!templateContext.outOfStockMode && (
					<div className="topLine__itemsLeft">
						<span>{data.tr_checkout_v3_header_stockLeft}</span>
						<span className="topLine__ribbon"></span>
					</div>
				)}
			</div>
		</header>
	);
};

export default Header;
